<template>
  <div class="ui container">
    <div style="text-align: center;">
      We sent a 6-digit authentication code to your registered mobile number +63917****314
    </div>
    <div style="text-align: center; margin-top: 10px;">
      Please enter the authentication code.
    </div>
    <div class="button-div">
      <button class="ui fluid primary button" @click="submit">
        Submit
      </button>
    </div>
    <div class="button-div">
      <button class="ui fluid primary button" @click="link">
        Kunware nag-link
      </button>
    </div>
    Error Message{{ debugMessage }}
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      phoneNumber: '',
      chosenLoad: '',
      discountVoucher: '',
      debugMessage: null
    }
  },
  mounted () {
    this.phoneNumber = this.$route.params.phone_number
    this.chosenLoad = this.$route.params.chosen_load
    this.discountVoucher = this.$route.params.discount_voucher
  },
  methods: {
    link () {
      const _this = this

      // eslint-disable-next-line
      MessengerExtensions.getContext('717995625387159',
        function success (threadContext) {
          console.log(threadContext)
          _this.debugMessage = threadContext

          axios.post('https://8cdfab75.ngrok.io/onboarding/result', {
            psid: threadContext.psid,
            type: 'link'
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          })
        }, function error (err, data) {
          console.log(err, data)
          _this.debugMessage = data
          if (err) {
          }
        }
      )
    },
    submit () {
      const refNumber = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.phoneNumber = '914564646'
      this.discountVoucher = '12313'
      this.chosenLoad = '123'
      const transDetails = {
        purchased_load: 'Regular PHP ' + this.chosenLoad,
        discount: this.discountVoucher,
        total_amount: this.chosenLoad,
        reference_number: refNumber,
        mobile_number_ending_digits: this.phoneNumber.substr(this.phoneNumber.length - 4)
      }
      console.log(transDetails)
      const _this = this
      // eslint-disable-next-line
      MessengerExtensions.getContext('717995625387159',
        function success (threadContext) {
          console.log(threadContext)
          _this.debugMessage = threadContext

          axios.post('https://8cdfab75.ngrok.io/dashboard/buy-load', {
            psid: threadContext.psid,
            transaction_details: transDetails,
            success: true
          }).then(data => {
            if (data.data.success) {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(success => {
              }, err => {
                if (err) {

                }
              })
            }
          })
        }, function error (err, data) {
          console.log(err, data)
          _this.debugMessage = data
          if (err) {
          }
        }
      )
    }
  }
}
</script>

<style scoped>
.button-div {
  margin-top: 20px;
}
button {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyLoad/OTP.vue